import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import './assets/style.scss';
import './assets/fonts.scss';
import VueMeta from 'vue-meta'
import vuescroll from 'vuescroll';
import axios from 'axios';


Vue.use(VueMeta)
Vue.use(vuescroll);

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  const loggedIn = store.getters['backend_auth/loggedIn']
  if (to.matched.some(record => record.meta.requiresVisitor)) {
    if (loggedIn) {
      next({
        name: 'AdminProfile',
      })
    } else {
      next()
    }
  }else if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!loggedIn) {
      next({
        name: 'Login',
      })
    } else {
      next()
    }
  }{
    next() // make sure to always call next()!
  }
})

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
